module.exports = __webpack_public_path__ + "img/teamio-logo.f3c44253.png";